import { AuthorLink, OtherAuthors } from "./utils"

import { ArticleTags } from "components/article-components"
import React from "react"

import {
  MapMarkerIcon,
  ClockIcon,
} from "components/page-components/Icons/small"

export const ArticleHeader = ({
  advertorial,
  display_date,
  headline,
  human_authors,
  is_comment,
  is_exclusive,
  is_h1,
  kicker,
  last_update_display,
  located,
  ressort,
  teaser,
  text_color,
}) => {
  const has_tags =
    !!is_comment || !!is_exclusive || !!advertorial?.is_advertorial
  const first_author = human_authors[0]
  const other_authors = human_authors.slice(1)

  return (
    <React.Fragment>
      {has_tags || !!kicker ? (
        <div className="level article-metadata pt-5 mb-0">
          <div className="level-left">
            {has_tags ? (
              <div className="level-item">
                <ArticleTags
                  {...{
                    ressort,
                    is_comment,
                    is_exclusive,
                    advertorial,
                  }}
                />
              </div>
            ) : null}
            <div className="level-item">
              <p className={`subtitle has-text-${ressort} is-6`}>{kicker}</p>{" "}
            </div>
          </div>
        </div>
      ) : null}
      {is_h1 ? (
        <h1
          className={`title is-2 is-size-4-mobile my-4${
            !!text_color ? ` has-text-${text_color}` : ""
          }`}
        >
          {headline}
        </h1>
      ) : (
        <h2
          className={`title is-2 is-size-4-mobile my-5${
            !!text_color ? ` has-text-${text_color}` : ""
          }`}
        >
          {headline}
        </h2>
      )}
      <div style={{ position: "relative" }}>
        <div
          className="level help article-metadata no-scrollbar"
          style={{ overflow: "auto" }}
        >
          <div className="level-left">
            {!!first_author?.name ? (
              <div
                className="level is-mobile mb-0 pb-2-mobile no-scrollbar"
                style={{ overflow: "auto" }}
              >
                <div className="level-left">
                  <AuthorLink {...{ author: first_author, ressort }} />
                  {!!other_authors.length ? (
                    <OtherAuthors {...{ ressort, other_authors }} />
                  ) : null}
                </div>
              </div>
            ) : null}

            <div
              className="level is-mobile no-scrollbar"
              style={{ overflow: "auto" }}
            >
              <div className="level-left" x-bi-data-nosnippet="true">
                <div
                  className={`level-item mr-1${
                    !!text_color ? ` has-text-${text_color}` : ""
                  }`}
                >
                  <span className="icon">
                    <ClockIcon {...{ color: "#4a4a4a", size: 0.55 }} />
                  </span>
                  <span>
                    {!!last_update_display &&
                    last_update_display === display_date
                      ? "aktualisiert "
                      : ""}
                    {display_date}
                    {!!last_update_display &&
                    last_update_display !== display_date
                      ? `, aktualisiert ${last_update_display}`
                      : null}
                  </span>
                </div>

                {!!located?.[0] ? (
                  <div
                    className={`level-item${
                      !!text_color ? ` has-text-${text_color}` : ""
                    }`}
                  >
                    <span className="icon">
                      <MapMarkerIcon {...{ color: "#4a4a4a", size: 0.55 }} />
                    </span>
                    {located.map((location, index) => (
                      <span key={`location-item-${index}`}>{location}</span>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {!!teaser ? (
        <p className="subtitle my-5 is-size-6-mobile" x-bi-teaser="true">
          {teaser}
        </p>
      ) : null}
    </React.Fragment>
  )
}
